"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseAbilityOnRandomEnemyActionHandler = exports.UseAbilityOnRandomEnemyActionArgs = void 0;
const Registries_1 = require("../../state/Registries");
const ActionType_1 = require("../ActionType");
const Target_1 = require("../../Target");
const AbilityArgs_1 = require("../../abilities/AbilityArgs");
const Random_1 = require("../../../utils/Random");
class UseAbilityOnRandomEnemyActionArgs {
    constructor(ability, requireSlotted = true) {
        this.ability = ability;
        this.requireSlotted = requireSlotted;
        this.__type = ActionType_1.ActionType.UseAbilityOnRandomEnemy;
        this.__typeName = "UseAbilityOnRandomEnemy";
    }
}
exports.UseAbilityOnRandomEnemyActionArgs = UseAbilityOnRandomEnemyActionArgs;
let UseAbilityOnRandomEnemyActionHandler = class UseAbilityOnRandomEnemyActionHandler {
    activate(sequence, container, action) {
        const next = (0, Random_1.randomElement)(container.selectLivingTargets(action.actorId, Target_1.Target.AllEnemies));
        const args = AbilityArgs_1.AbilityArgs.FromTypeName(action.args.ability, Target_1.Target.OneEnemy(next));
        container.useAbility(sequence, action.actorId, args, action.args.requireSlotted);
    }
};
UseAbilityOnRandomEnemyActionHandler = __decorate([
    Registries_1.Actions.register(ActionType_1.ActionType.UseAbilityOnRandomEnemy)
], UseAbilityOnRandomEnemyActionHandler);
exports.UseAbilityOnRandomEnemyActionHandler = UseAbilityOnRandomEnemyActionHandler;
